import { videoStatus, LiveStatus } from '@/json/index'
// 往期视频筛选
export let videoFilterLabel = [{
  label: '录制时间',
  type: 'time-slot',
  startName: 'recordingStart', // 返回数据时，开始时间的字段名
  endName: 'recordingEnd', // 返回数据时，结束时间的字段名
  value: 'crecordingTime'
},
{
  label: '状态',
  type: 'select',
  value: 'status',
  clearable: true,
  filterable: true,
  options: videoStatus
}]
// 往期视频列表
export let videoTableLabels = [
  {
    label: '视频名称',
    value: 'name'
  },
  {
    label: '状态',
    value: 'status_copy'
  },
  {
    label: '录制时间',
    value: 'recordingTime_copy'
  },
  {
    label: '上传时间',
    value: 'uploadTime_copy'
  }
]
// 往期视频筛选
export let liveFilterLabel = [{
  label: '状态',
  type: 'select',
  value: 'status',
  clearable: true,
  filterable: true,
  options: LiveStatus
}, {
  label: '开始时间',
  type: 'time-slot',
  startName: 'start', // 返回数据时，开始时间的字段名
  endName: 'end', // 返回数据时，结束时间的字段名
  value: 'startTime'
}]
// 往期视频列表
export let liveTableLabels = [
  {
    label: '直播标题',
    value: 'name'
  },
  {
    label: '状态',
    value: 'status_copy'
  },
  {
    label: '主讲人',
    value: 'speaker'
  },
  {
    label: '开始时间',
    value: 'start_copy'
  },
  {
    label: '结束时间',
    value: 'end_copy'
  }
]
export let tableLabels = [{
  label: '视频名称',
  value: 'name'
}, {
  label: '申请人',
  value: 'applyUser.fullName'
}, {
  label: '录制时间',
  value: 'recordingTime_copy'
}, {
  label: '创建时间',
  value: 'createdDate_copy'
}]

export let tableLabelsOk = [...tableLabels, {
  label: '发布时间',
  value: 'releaseTime_copy'
}, {
  label: '审批人',
  value: 'releaseUser.fullName'
}, {
  label: '视频状态',
  value: 'status_copy'
}]
